<template>
  <tags-table />
</template>

<script>
import TagsTable from 'VuePartials/App/Preferences/Tags/TagsTable';

export default {
  components: {
    TagsTable,
  },
};
</script>
